function get_subsection(section, subIdx) {
  const subsections = Reflect.get(section || {}, 'subsections');
  return Array.isArray(subsections) ? Reflect.get(subsections, subIdx) || null : null;
}

const methods = {
    async switch_to_edit() {
      this.mode = 'edit';
      await this.cleanup_editors();
      this.$nextTick(() => this.init_editors());
    },

    // ---------------------------------------------------
    // SECTION CRUD OPERATIONS
    // ---------------------------------------------------
    add_section() {
      this.sections.push(this.create_empty_section());
      
      this.$nextTick(() => {
        const idx = this.sections.length - 1;
        this.init_section_editors(idx);
      });
    },

    async remove_section(idx) {
      await this.destroy_section_editors(idx);
      this.sections.splice(idx, 1);
    },

    add_subsection(sidx) {
      const section = Reflect.get(this.sections, sidx);
      if (!section) return;
      section.subsections.push(this.create_empty_subsection());
      this.$nextTick(() => {
        const subIdx = section.subsections.length - 1;
        this.init_section_editors(sidx, subIdx);
      });
    },

    async remove_subsection(sidx, subIdx) {
      const section = Reflect.get(this.sections, sidx);
      const subsections = Reflect.get(section || {}, 'subsections');
      if (!Array.isArray(subsections) || !Reflect.get(subsections, subIdx)) return;
      await this.destroy_section_editors(sidx, subIdx);
      subsections.splice(subIdx, 1);
    },

    get_content_block(sidx, subIdx = null) {
      const section = Reflect.get(this.sections, sidx);
      if (!section) return null;
      return subIdx == null ? section : get_subsection(section, subIdx);
    },
    build_table_cell_editor_id(sidx, rIdx, cIdx, subIdx = null) {
      return subIdx === null
        ? `table_cell_${sidx}_${rIdx}_${cIdx}`
        : `sub_table_cell_${sidx}_${subIdx}_${rIdx}_${cIdx}`;
    },

    add_description(sidx, subIdx = null) {
      const target = this.get_content_block(sidx, subIdx);
      if (!target) return;
      target.descriptions.push('');
      this.$nextTick(() => {
        const dIdx = target.descriptions.length - 1;
        const editor_id = subIdx === null
          ? `description_text_${sidx}_${dIdx}`
          : `sub_description_text_${sidx}_${subIdx}_${dIdx}`;
        this.make_richedit(editor_id);
      });
    },

    async remove_description(sidx, dIdx, subIdx = null) {
      const editor_id = subIdx === null
        ? `description_text_${sidx}_${dIdx}`
        : `sub_description_text_${sidx}_${subIdx}_${dIdx}`;
      await this.destroy_ck_editor(editor_id);

      const target = this.get_content_block(sidx, subIdx);
      if (!target) return;
      if (target.descriptions.length > 1) {
        target.descriptions.splice(dIdx, 1);
      }
      
      this.$nextTick(() => this.init_section_editors(sidx, subIdx));
    },

    add_column(sidx, afterIdx, subIdx = null) {
      const section = this.get_content_block(sidx, subIdx);
      if (!section) return;
      const insertIdx = afterIdx + 1;
      section.table.headers.splice(insertIdx, 0, { label: `Column ${section.table.headers.length + 1}` });
      section.table.rows.forEach((row) => {
        row.splice(insertIdx, 0, '');
      });
      this.$nextTick(() => this.init_section_editors(sidx, subIdx));
    },

    async remove_column(sidx, cIdx, subIdx = null) {
      const section = this.get_content_block(sidx, subIdx);
      if (!section) return;
      if (section.table.headers.length <= 1) return;
      
      // Destroy editors for this column
      for (let rIdx = 0; rIdx < section.table.rows.length; rIdx++) {
        await this.destroy_ck_editor(this.build_table_cell_editor_id(sidx, rIdx, cIdx, subIdx));
      }
      
      section.table.headers.splice(cIdx, 1);
      section.table.rows.forEach((row) => {
        row.splice(cIdx, 1);
      });
      this.$nextTick(() => this.init_section_editors(sidx, subIdx));
    },

    add_row(sidx, subIdx = null) {
      const section = this.get_content_block(sidx, subIdx);
      if (!section) return;
      const cols = section.table.headers.length || 1;
      const newRow = new Array(cols).fill('');
      section.table.rows.push(newRow);
      
      const rIdx = section.table.rows.length - 1;
      this.$nextTick(() => {
        for (let cIdx = 0; cIdx < cols; cIdx++) {
          const editor_id = subIdx === null
            ? `table_cell_${sidx}_${rIdx}_${cIdx}`
            : `sub_table_cell_${sidx}_${subIdx}_${rIdx}_${cIdx}`;
          this.make_richedit(editor_id);
        }
      });
    },

    async remove_row(sidx, rIdx, subIdx = null) {
      const section = this.get_content_block(sidx, subIdx);
      if (!section) return;
      if (section.table.rows.length <= 1) return;
      
      // Destroy editors for this row
      const row = Reflect.get(section.table.rows, rIdx);
      for (let cIdx = 0; cIdx < row.length; cIdx++) {
        await this.destroy_ck_editor(this.build_table_cell_editor_id(sidx, rIdx, cIdx, subIdx));
      }
      
      section.table.rows.splice(rIdx, 1);
      this.$nextTick(() => this.init_section_editors(sidx, subIdx));
    },

    // ---------------------------------------------------
    // CKEDITOR MANAGEMENT
};

export default methods;

